// import React from "react";
// import {
//   Page,
//   Text,
//   View,
//   Document,
//   StyleSheet,
//   Image,
// } from "@react-pdf/renderer";

// const styles = StyleSheet.create({
//   page: {
//     paddingTop: 90,
//     paddingBottom: 90,
//     paddingHorizontal: 20,
//     fontSize: 9,
//     backgroundColor: "#FFFFFF",
//   },

//   /* HEADER */
//   headerWrapper: {
//     position: "absolute",
//     top: 10,
//     left: 20,
//     right: 20,
//     height: 60,
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   headerImage: {
//     width: "100%",
//     height: 55,
//     resizeMode: "contain",
//   },

//   /* FOOTER */
//   footerWrapper: {
//     position: "absolute",
//     bottom: 5,
//     left: 10,
//     right: 10,
//     height: 60,
//     justifyContent: "center",
//     alignItems: "center",
//   },

//   footerImage: {
//     width: "100%",
//     height: 55,
//     resizeMode: "stretch",
//   },

//   title: {
//     fontSize: 16,
//     fontWeight: "bold",
//     textAlign: "center",
//     marginBottom: 15,
//   },

//   /* TABLE */
//   table: {
//     width: "100%",
//     borderWidth: 1,
//     borderColor: "#000",
//     borderStyle: "solid",
//   },

//   tableRow: {
//     flexDirection: "row",
//     minHeight: 28,
//     alignItems: "center",
//     borderBottomWidth: 1,
//     borderBottomColor: "#000",
//     borderBottomStyle: "solid",
//   },

//   headerRow: {
//     backgroundColor: "#EAEAEA",
//   },

//   cellHeader: {
//     padding: 5,
//     fontWeight: "bold",
//     textAlign: "center",
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     borderRightStyle: "solid",
//   },

//   cell: {
//     padding: 5,
//     borderRightWidth: 1,
//     borderRightColor: "#000",
//     borderRightStyle: "solid",
//     justifyContent: "center",
//   },

//   lastCell: {
//     borderRightWidth: 0,
//   },

//   slNo: {
//     width: 35,
//     textAlign: "center",
//     borderTopColor: "#000",
//     borderTopWidth: 1,
//   },

//   standard: {
//     width: 200,
//      borderTopColor: "#000",
//     borderTopWidth: 1,
//   },

//   student: {
//     width: 200,
//      borderTopColor: "#000",
//     borderTopWidth: 1,
//   },

//   date: {
//     width: 85,
//     textAlign: "center",
//      borderTopColor: "#000",
//     borderTopWidth: 1,
//   },

//   amount: {
//     width: 90,
//     textAlign: "right",
//      borderTopColor: "#000",
//     borderTopWidth: 1,
//   },

//   due: {
//     width: 80,
//     textAlign: "right",
//      borderTopColor: "#000",
//     borderTopWidth: 1,
//   },

//   status: {
//  width: 60,
//     textAlign: "center",
//      borderTopColor: "#000",
//     borderTopWidth: 1,
//   },

//   /* PAGE NUMBER */
//   pageNumber: {
//     position: "absolute",
//     bottom: 72,
//     left: 0,
//     right: 0,
//     textAlign: "center",
//     fontSize: 9,
//     color: "#555",
//   },
// });
// // const styles = StyleSheet.create({
// //   page: {
// //     padding: 20,
// //     fontSize: 10,
// //   },

// //  /* HEADER */
// //     headerWrapper: {
// //         position: "absolute",
// //         top: 20,
// //         left: 20,
// //         right: 20,
// //         height: 50,
// //         justifyContent: "center",
// //         alignItems: "center",
// //     },

// //     headerImage: {
// //         width: "100%",
// //         height: 60,
// //         objectFit: "contain",
// //     },
// //     /* FOOTER */
// //     footerWrapper: {
// //         position: "absolute",
// //         bottom: 30,
// //         left: 5,
// //         right: 5,     // forces full width
// //         height: 80,
// //         justifyContent: "center",
// //         alignItems: "center",
// //     },

// //     footerImage: {
// //         width: "100%",
// //         height: 100,
// //         objectFit: "cover",
// //     },
// //   title: {
// //     // textAlign: "center",
// //     // fontSize: 15,
// //     // marginBottom: 15,
// //     // fontWeight: "bold",
// //      fontSize: 16,
// //     fontWeight: "bold",
// //     textAlign: "center",
// //     marginBottom: 10,
// //     marginTop: 80
// //   },

// //   table: {
// //     width: "100%",
// //     borderWidth: 1,
// //     borderColor: "#000",
// //   },

// //   // tableRow: {
// //   //   flexDirection: "row",
// //   //   borderBottomWidth: 1,
// //   //   borderBottomColor: "#000",
// //   //   minHeight: 28,
// //   //   alignItems: "center",
// //   // },
// //     tableRow: {
// //     flexDirection: "row",
// //     borderBottomWidth: 1,
// //     borderBottomColor: "#000",
// //     borderBottomStyle: "solid",
// //     height:30,
// //   },

// //   headerRow: {
// //     backgroundColor: "#EAEAEA",
// //   },

// //   cellHeader: {
// //     fontWeight: "bold",
// //     textAlign: "center",
// //     padding: 4,
// //     borderRightWidth: 1,
// //     borderRightColor: "#000",
// //   },

// //   cell: {
// //     padding: 4,
// //     borderRightWidth: 1,
// //     borderRightColor: "#000",
// //   },

// //   lastCell: {
// //     borderRightWidth: 0,
// //   },

// //   slNo: {
// //     width: 35,
// //     textAlign: "center",
// //   },

// //   standard: {
// //     width: 120,
// //   },

// //   student: {
// //     width: 120,
// //   },

// //   date: {
// //     width: 90,
// //     textAlign: "center",
// //   },

// //   amount: {
// //     width: 90,
// //     textAlign: "right",
// //   },

// //   due: {
// //     width: 80,
// //     textAlign: "right",
// //   },

// //   status: {
// //     flex: 1,
// //     textAlign: "center",
// //   },

// //   pageNumber: {
// //     position: "absolute",
// //     bottom: 65,
// //     left: 0,
// //     right: 0,
// //     textAlign: "center",
// //     fontSize: 9,
// //   },
// // });

// const FIRST_PAGE_COUNT = 8;
// const OTHER_PAGE_COUNT = 10;

// const paginateData = (data) => {
//   const pages = [];

//   pages.push(data.slice(0, FIRST_PAGE_COUNT));

//   for (
//     let i = FIRST_PAGE_COUNT;
//     i < data.length;
//     i += OTHER_PAGE_COUNT
//   ) {
//     pages.push(data.slice(i, i + OTHER_PAGE_COUNT));
//   }

//   return pages;
// };

// const TeacherinvoicePDF = ({ data = [], filters = {} }) => {
//   const pages = paginateData(data);

//   return (
//     <Document>
//       {pages.map((pageData, pageIndex) => (
//         <Page
//           key={pageIndex}
//           size="A4"
//           orientation="landscape"
//           style={styles.page}
//         >
//           {/* HEADER */}
//           <View fixed style={styles.headerWrapper}>
//             {filters.HeaderImg && (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
//                 style={styles.headerImage}
//               />
//             )}
//           </View>

//           {/* TITLE */}
//           {pageIndex === 0 && (
//             <Text style={styles.title}>
//               Teacher Invoice - {filters.EmployeeID}
//             </Text>
//           )}

//           {/* TABLE */}
//           <View style={styles.table, pageIndex !== 0 && { marginTop: 10 }} >
//             {/* HEADER ROW */}
//             <View style={[styles.tableRow, styles.headerRow]}>
//               <Text style={[styles.cellHeader, styles.slNo]}>
//                 SL#
//               </Text>

              
//               <Text style={[styles.cellHeader, styles.standard]}
//                 wrap={false}
//               >
//                 Standards
//               </Text>

//               <Text style={[styles.cellHeader, styles.student]}>
//                 Students
//               </Text>

//               <Text style={[styles.cellHeader, styles.date]}>
//                 Date
//               </Text>

//               <Text style={[styles.cellHeader, styles.amount]}>
//                 Total Amount
//               </Text>

//               <Text style={[styles.cellHeader, styles.amount]}>
//                 Paid Amount
//               </Text>

//               <Text style={[styles.cellHeader, styles.due]}>
//                 Due
//               </Text>

//               <Text
//                 style={[
//                   styles.cellHeader,
//                   styles.status,
//                   styles.lastCell,
//                 ]}
//               >
//                 Status
//               </Text>
//             </View>

//             {/* DATA ROWS */}
//             {pageData.map((row, rowIndex) => {
//               const globalIndex =
//                 pageIndex === 0
//                   ? rowIndex + 1
//                   : FIRST_PAGE_COUNT +
//                     (pageIndex - 1) * OTHER_PAGE_COUNT +
//                     rowIndex +
//                     1;

//               return (
//                 <View key={rowIndex} style={styles.tableRow}>
//                   <Text style={[styles.cell, styles.slNo]}>
//                     {globalIndex}
//                   </Text>

//                   <Text style={[styles.cell, styles.standard]}>
//                     {row.Project || ""}
//                   </Text>

//                   <Text style={[styles.cell, styles.student]}>
//                     {row.Employee || ""}
//                   </Text>

//                   <Text style={[styles.cell, styles.date]}>
//                     {row.DATE || ""}
//                   </Text>

//                   <Text style={[styles.cell, styles.amount]}>
//                     {row.TotalAmount || ""}
//                   </Text>

//                   <Text style={[styles.cell, styles.amount]}>
//                     {row.PaidAmount || ""}
//                   </Text>

//                   <Text style={[styles.cell, styles.due]}>
//                     {row.Due || ""}
//                   </Text>

//                   <Text
//                     style={[
//                       styles.cell,
//                       styles.status,
//                       styles.lastCell,
//                     ]}
//                   >
//                     {row.PaymentStatus || ""}
//                   </Text>
//                 </View>
//               );
//             })}
//           </View>

//           {/* PAGE NUMBER */}
//           {/* <Text style={styles.pageNumber}>
//             Page {pageIndex + 1} of {pages.length}
//           </Text> */}
//           <Text
//   style={styles.pageNumber}
//   render={({ pageNumber, totalPages }) =>
//     `Page ${pageNumber} of ${totalPages}`
//   }
//   fixed
// />

//           {/* FOOTER */}
//           <View fixed style={styles.footerWrapper}>
//             {filters.FooterImg && (
//               <Image
//                 src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
//                 style={styles.footerImage}
//               />
//             )}
//           </View>
//         </Page>
//       ))}
//     </Document>
//   );
// };

// export default TeacherinvoicePDF;

import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    paddingTop: 75,
    paddingBottom: 95,
    paddingHorizontal: 25,
    fontSize: 9,
    backgroundColor: "#FFFFFF",
  },

  /* ── HEADER ── */
  headerWrapper: {
    position: "absolute",
    top: 8,
    left: 25,
    right: 25,
    height: 60,
  },
  headerImage: {
    width: "100%",
    height: 60,
    objectFit: "contain",
  },

  /* ── FOOTER ── */
  footerWrapper: {
    position: "absolute",
    bottom: 8,
    left: 25,
    right: 25,
    height: 72,
    width: "100%"
  },
  footerImage: {
    width: "100%",
    height: 72,
    objectFit: "contain",
  },

  /* ── TITLE ── */
  title: {
    fontSize: 14,
    fontWeight: "bold",
    textAlign: "center",
    marginBottom: 12,
  },

  /* ── TABLE OUTER BORDER (all 4 sides) ── */
  table: {
    width: "100%",
    borderTopWidth: 1,
    borderLeftWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "#000000",
    borderStyle: "solid",
  },

  /* ── ROWS ── */
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: "#000000",
    borderBottomStyle: "solid",
    minHeight: 26,
    alignItems: "stretch",
  },

  lastRow: {
    borderBottomWidth: 0,
  },

  headerRow: {
    backgroundColor: "#EAEAEA",
  },

  /* ── HEADER CELLS ── */
  cellHeader: {
    paddingVertical: 6,
    paddingHorizontal: 5,
    fontWeight: "bold",
    textAlign: "center",
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    justifyContent: "center",
    alignItems: "center",
  },

  /* ── DATA CELLS ── */
  cell: {
    paddingVertical: 5,
    paddingHorizontal: 5,
    borderRightWidth: 1,
    borderRightColor: "#000000",
    borderRightStyle: "solid",
    justifyContent: "center",
  },

  /* last column — no right border (table border covers it) */
  lastCell: {
    borderRightWidth: 0,
  },

  /* ── COLUMN WIDTHS ── */
  slNo: {
    width: 32,
    textAlign: "center",
  },
  standard: {
    width: 165,
    textAlign: "left",
  },
  student: {
    width: 140,
    textAlign: "left",
  },
  date: {
    width: 82,
    textAlign: "center",
  },
  amount: {
    width: 85,
    textAlign: "right",
  },
  due: {
    width: 75,
    textAlign: "right",
  },
  status: {
    flex: 1,
    textAlign: "center",
  },

  /* ── PAGE NUMBER ── */
  pageNumber: {
    position: "absolute",
    bottom: 83,
    left: 0,
    right: 0,
    textAlign: "center",
    fontSize: 8,
    color: "#555555",
  },
});

const FIRST_PAGE_COUNT = 8;
const OTHER_PAGE_COUNT = 10;

const paginateData = (data) => {
  const pages = [];
  pages.push(data.slice(0, FIRST_PAGE_COUNT));
  for (let i = FIRST_PAGE_COUNT; i < data.length; i += OTHER_PAGE_COUNT) {
    pages.push(data.slice(i, i + OTHER_PAGE_COUNT));
  }
  return pages;
};

const safe = (val) =>
  val !== null && val !== undefined ? String(val) : "";

const TeacherinvoicePDF = ({ data = [], filters = {} }) => {
  const pages = paginateData(data);

  return (
    <Document>
      {pages.map((pageData, pageIndex) => (
        <Page
          key={pageIndex}
          size="A4"
          orientation="landscape"
          style={styles.page}
        >
          {/* ══ HEADER ══ */}
          <View fixed style={styles.headerWrapper}>
            {filters.HeaderImg ? (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.HeaderImg}`}
                style={styles.headerImage}
              />
            ) : null}
          </View>

          {/* ══ TITLE (page 1 only) ══ */}
          {pageIndex === 0 && (
            <Text style={styles.title}>
              Teacher Invoice - {safe(filters.EmployeeID)}
            </Text>
          )}

          {/* ══ TABLE ══ */}
          <View
            style={[
              styles.table,
              pageIndex !== 0 && { marginTop: 10 },
            ]}
          >
            {/* ── HEADER ROW ── */}
            <View style={[styles.tableRow, styles.headerRow]}>
              <Text style={[styles.cellHeader, styles.slNo]}>
                SL#
              </Text>
              <Text style={[styles.cellHeader, styles.standard]}>
                Standards
              </Text>
              <Text style={[styles.cellHeader, styles.student]}>
                Students
              </Text>
              <Text style={[styles.cellHeader, styles.date]}>
                Date
              </Text>
              <Text style={[styles.cellHeader, styles.amount]}>
                Total Amount
              </Text>
              <Text style={[styles.cellHeader, styles.amount]}>
                Paid Amount
              </Text>
              <Text style={[styles.cellHeader, styles.due]}>
                Due
              </Text>
              <Text
                style={[
                  styles.cellHeader,
                  styles.status,
                  styles.lastCell,
                ]}
              >
                Status
              </Text>
            </View>

            {/* ── DATA ROWS ── */}
            {pageData.map((row, rowIndex) => {
              const isLastRow = rowIndex === pageData.length - 1;
              const globalIndex =
                pageIndex === 0
                  ? rowIndex + 1
                  : FIRST_PAGE_COUNT +
                    (pageIndex - 1) * OTHER_PAGE_COUNT +
                    rowIndex +
                    1;

              return (
                <View
                  key={rowIndex}
                  style={[
                    styles.tableRow,
                    isLastRow && styles.lastRow,
                  ]}
                >
                  <Text style={[styles.cell, styles.slNo]}>
                    {globalIndex}
                  </Text>
                  <Text style={[styles.cell, styles.standard]}>
                    {safe(row.Project)}
                  </Text>
                  <Text style={[styles.cell, styles.student]}>
                    {safe(row.Employee)}
                  </Text>
                  <Text style={[styles.cell, styles.date]}>
                    {safe(row.DATE)}
                  </Text>
                  <Text style={[styles.cell, styles.amount]}>
                    {safe(row.TotalAmount)}
                  </Text>
                  <Text style={[styles.cell, styles.amount]}>
                    {safe(row.PaidAmount)}
                  </Text>
                  <Text style={[styles.cell, styles.due]}>
                    {safe(row.Due)}
                  </Text>
                  <Text
                    style={[
                      styles.cell,
                      styles.status,
                      styles.lastCell,
                    ]}
                  >
                    {safe(row.PaymentStatus)}
                  </Text>
                </View>
              );
            })}
          </View>

          {/* ══ PAGE NUMBER ══ */}
          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `Page ${pageNumber} of ${totalPages}`
            }
            fixed
          />

          {/* ══ FOOTER ══ */}
          <View fixed style={styles.footerWrapper}>
            {filters.FooterImg ? (
              <Image
                src={`${filters.Imageurl}/uploads/images/${filters.FooterImg}`}
                style={styles.footerImage}
              />
            ) : null}
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default TeacherinvoicePDF;